import { apiRequest } from "../utils/config/apiRequest";
import { apiUrl } from "../utils/endPoints/apiUrl";

export const fetchPayout = async(query = {}) => {
  try {
    const response = await apiRequest({
      endUrl: apiUrl.payouts.payoutListing,
      method: "GET",
      query,
    });

    if (response.status === true) {
      return {
        success: true,
        data: response.data,
      };
    } else {
      throw new Error(response.message || "Failed");
    }
  } catch (error) {
    console.error("Error in Fetching Payout:", error);
    return { success: false, error: error.message };
  }
};


